import { pipe, prop, propOr } from 'ramda';
import { Posts } from 'src/blog-item/types';
import type { RootState } from 'src/redux';

const selectAllBlogItemState = (state: RootState) => state.blogItem;

export const selectPostBySlug = (state: RootState, slug: string) =>
  pipe(selectAllBlogItemState, prop(slug))(state);

export const selectIsLoading = (state: RootState, slug: string) =>
  pipe(selectPostBySlug, propOr(false, 'isLoading'))(state, slug) as boolean;

export const selectNormalizedPostsBySlug = (
  state: RootState,
  slugs: string[]
) =>
  slugs.reduce((posts, slug) => {
    posts[slug] = selectPostBySlug(state, slug);
    return posts;
  }, {} as Posts);
